import React, { createContext, useContext, useEffect, useState } from 'react';

const MOBILE_BREAKPOINT = '(max-width: 900px)';

const LayoutContext = createContext(null);

function getIsMobile() {
  return window.matchMedia(MOBILE_BREAKPOINT).matches;
}

export function LayoutProvider({ children }) {
  const [isMobile, setIsMobile] = useState(getIsMobile);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    if (getIsMobile()) return true;
    return localStorage.getItem('sidebarCollapsed') === 'true';
  });

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_BREAKPOINT);
    const handleChange = (event) => {
      setIsMobile(event.matches);
      if (event.matches) {
        setSidebarCollapsed(true);
      }
    };

    setIsMobile(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  useEffect(() => {
    if (!isMobile) {
      localStorage.setItem('sidebarCollapsed', String(sidebarCollapsed));
    }
  }, [sidebarCollapsed, isMobile]);

  useEffect(() => {
    if (isMobile && !sidebarCollapsed) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobile, sidebarCollapsed]);

  const toggleSidebar = () => setSidebarCollapsed((prev) => !prev);
  const closeSidebar = () => setSidebarCollapsed(true);

  return (
    <LayoutContext.Provider
      value={{ sidebarCollapsed, toggleSidebar, closeSidebar, setSidebarCollapsed, isMobile }}
    >
      {children}
    </LayoutContext.Provider>
  );
}

export function useLayout() {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayout must be used within LayoutProvider');
  }
  return context;
}
